<template>
  <fg-input type="text"
  v-bind:class="classObject"
  v-model="orario"
  />
</template>
<script>
  export default {
    props: ['value'],
    data () {
      return {
        orario: this.format(this.value),
        classObject: this.class
      }
    },
    watch: {
      orario (newValue) {
        this.orario = this.format(newValue)
        this.$emit('input', this.orario)
      }
    },
    methods: {
      format (v) {
        if (typeof v === 'string' && (v.indexOf(':') !== -1 || v.indexOf('.') !== -1 || v.indexOf(',') !== -1)) {
          v = v.replace('.', ':').replace(',', ':')
          var array = v.split(':')
          v = (parseInt(array[0]) || 0) + ':'
          if (array[1]) {
            v += array[1].replace(/\D/g, '')
          }
        } else {
          v = v.replace(/\D/g, '')
        }
        if (v === '0:00') {
          v = ''
        }
        return v
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Orario.vue